module.exports = __webpack_public_path__ + "static/img/no-user.cc1d858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-user.png
// module id = 459
// module chunks = 4